module.exports = __webpack_public_path__ + "assets/img/lianzi1.63d0adf4.jpg";